export default __webpack_public_path__ + "static/media/ic_menu_expand.8a16bf0b.svg";